// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__3C2A0","social":"footer_social__2wbR6","link":"footer_link__2Vr6R","copyright":"footer_copyright__2ggo0","contacts":"footer_contacts__10vKs"};